import { Title } from '@angular/platform-browser';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '@app/_services';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MastersuiteService } from '../mastersuite.service';
import { ToastrService } from 'ngx-toastr';
import { SharedUtilService } from '@app/_shared/shared-util.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReusableTableComponent } from '@app/_shared/reusable-table/reusable-table.component';
import { EndpointBulkDeleteModalComponent } from '@app/endpoint/endpoint-bulk-delete-modal/endpoint-bulk-delete-modal.component';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.less']
})
export class ListComponent implements OnInit {
  @ViewChild(ReusableTableComponent) reusableTable: ReusableTableComponent;
  mastersuiteList = [];
  masterSuiteSearchForm: FormGroup;
  myProjectsList: any;
  collectionSize: any;
  page = 1;
  previousPage: any;
  pageSize = 15;
  tableHead:any=["Name","Project","Parallel","Updated On","Updated By"];
  user: any;
  currentPage:any;
  currentPageSize:any;

  masterSuiteSortList = [
    { id: 'name', name: 'Name' },
    { id: 'updatedOn', name: 'Updated On' },
    { id: 'createdOn', name: 'Created On' },
  ];
  masterSuiteSortOrder = "DESC";

  constructor(private route: ActivatedRoute, private router: Router, private _commonServices: CommonService, private formBuilder: FormBuilder, private mastersuiteservice: MastersuiteService, private titleService: Title, private toastr: ToastrService, private sharedUtilService: SharedUtilService, private modalService: NgbModal) { }

  ngOnInit() {
    this.titleService.setTitle('Mastersuite List');
    this.user = JSON.parse(localStorage.getItem('user'));
    this.setMasterSuiteSearchForm();
    this.myProjects();

    this.route.queryParams.subscribe(queryParams => {
      let searchParams = JSON.parse(JSON.stringify(queryParams));
        if(searchParams.default === undefined) {
          if(localStorage.getItem("defaultUserConfig") !== null && JSON.parse(localStorage.getItem("defaultUserConfig")).default_project) {
            searchParams.projectIds = [JSON.parse(localStorage.getItem("defaultUserConfig")).default_project];
          }
        } else {
          delete searchParams.default;
        }
      this.getMasterSuiteList(searchParams);
      this.currentPage = queryParams['page'] || 1;
      this.currentPageSize = queryParams['size'] || 15;
    });
  }

  myProjects(): void {
    this._commonServices.getMyProjects().pipe().subscribe(data => {
      this.myProjectsList = data.response;
    });
  }

  setMasterSuiteSearchForm(): void {
    this.masterSuiteSearchForm = this.formBuilder.group({
      keyword: [null],
      projectIds: [null],
      certified: [null],
      updatedBy: [null],
      createdBy: [null],
      parallelRun: [null],
      sortBy : ['updatedOn'],
      direction: ['DESC']
    });
  }

  setSearchFromParams(params): void {
    if (params.certified) { this.masterSuiteSearchForm.get('certified').setValue(JSON.parse(params.certified)); }
    if (params.subFlow) { this.masterSuiteSearchForm.get('nonFunctional').setValue(JSON.parse(params.subFlow)); }
    if (params.keyword) { this.masterSuiteSearchForm.get('keyword').setValue(params.keyword); }

    if (params.projectIds) {
      let projects = [];
      if (Array.isArray(params.projectIds)) {
        projects = params.projectIds.map((val) => {
          return parseInt(val, 10);
        });
      } else {
        const projectId = parseInt(params.projectIds, 10);
        projects.push(projectId);
      }
      this.masterSuiteSearchForm.get('projectIds').setValue(projects);
    }
  }

  getMasterSuiteList(queryParams: any): void {
    let searchParams = queryParams; /* Getting the query params */
    if (searchParams.keyword) {
      searchParams = { ...searchParams, keyword: searchParams.keyword.trim() };
    }
    this.setSearchFromParams(searchParams);

    this.mastersuiteservice.getMasterSuiteList(searchParams).pipe().subscribe(data => {
      if (data.code === 200) {
        this.mastersuiteList = data.response.masterSuites;
        this.collectionSize = data.response.count;
        this.page = searchParams.page;
      } else {
        this.mastersuiteList = [];
        this.collectionSize = 0;
        this.page = 1;
      }
    });
  }

  clearSearchFilter() {
    this.masterSuiteSearchForm.reset();
    this.pagination();
  }

  pagination(): void {
    let searchParams = this.masterSuiteSearchForm.value;
    const collection = {
      page: this.page || 1,
      size: this.pageSize || 15,
      default: false
    };
    searchParams = { ...collection, ...searchParams };

    this.router.navigate(['.'], { relativeTo: this.route, queryParams: searchParams });
  }

  onPageChange(page: number): void {
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.pagination();
    }
  }

  onSizeChange(size: number): void {
    this.pageSize = size;
    this.pagination();
  }
  deleteMultipleMasterSuites(selectedItems: any[]) {
    const associatedEntityList = [];
    const nonAssociatedEntityList = selectedItems;
    const confirmMessage = 'Are you sure you want to delete the non-associated mastersuites ?';
    const entityName = 'mastersuite';
    const modalRef = this.modalService.open(EndpointBulkDeleteModalComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.associatedEntityList = associatedEntityList;
    modalRef.componentInstance.nonAssociatedEntityList = nonAssociatedEntityList;
    modalRef.componentInstance.confirmMessage = confirmMessage;
    modalRef.componentInstance.entityType = entityName;

    modalRef.result.then((result) => {
      if (result) {
        const masterSuitesToDelete = selectedItems.map(item => item.id);
        const entityType = 'MASTER_SUITE';

        this.mastersuiteservice.deleteMultipleMastersuites(entityType, masterSuitesToDelete).subscribe((data) => {
          if (data.code === 200) {
            this.reusableTable.resetSelection();
            this.toastr.success(data.message);
            this.page = 1;
            const currentParams = {
              ...this.masterSuiteSearchForm.value,
              page: this.page,
              size: this.currentPageSize || 15,
              default: false
            };
            if(this.currentPage == 1){
              this.router.navigate(["."], {
              relativeTo: this.route,
              queryParams: currentParams,
            });
            delete currentParams.default;
            this.getMasterSuiteList(currentParams);
            }else{
              this.router.navigate(['/mastersuite'], { relativeTo: this.route, queryParams: currentParams });
            }
          } else {
            this.toastr.error(data.message);
          }
        });
      }
    }, (reason) => {
    });
  }

  optionToggledMasterSuite(index: string | number) {
    if (this.reusableTable) {
      this.reusableTable.optionToggled(index);
    }
  }
  
  deleteMasterSuite(item:any) {
    const confirmMsg = 'Are you sure you want to delete this Mastersuite ?';
    this.sharedUtilService.openConfirmDialog(confirmMsg, false).then((result) => {
      if (result) {
        this._commonServices.delete('MASTERSUITE', item).subscribe((data) => {
          if (data.code === 200) {
            this.reusableTable.resetSelection()
            this.toastr.success(data.message);
            const currentParams = {
              ...this.masterSuiteSearchForm.value,
              page: this.currentPage || 1,
              size: this.currentPageSize || 15
            };
            this.getMasterSuiteList(currentParams);
          }
        });
      }
    });
  }

  updateSortOrder(any) {
    this.masterSuiteSortOrder = any;
    this.masterSuiteSearchForm.get('direction').setValue(any);
  }

}
